export const PERIOD_CUSTOM = 'custom';
export const PERIOD_CURRENT_YEAR = 'currYear';
export const PERIOD_PREVIOUS_QUARTER = 'prevQuarter';
export const PERIOD_CURRENT_QUARTER = 'currQuarter';
export const PERIOD_LIFETIME = 'lifetime';